import React from "react";
import Context from "../../../Context";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import CertificateShipSelect from "./CertificateShipSelect";
import List from "../../Misc/List";
import Sortings from "../../Misc/Sortings";
import Filters from "../../Misc/Filters";
import Searchbox from "../../Misc/Searchbox";
import CertificateListItem from "./CertificateListItem";
import CertificateItem from "./CertificateItem";
import CertificateEdit from "./CertificateEdit";

export default class Certificate extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      editItem: false,
      rights: {},
      search: [],
      customListKey: "",
      filters: {
        show: false,
        active: [],
        default: [],
        all: [
          {
            id: "created",
            title: "По дате создания",
            kind: "range",
            active: false,
            value: [],
          },
        ],
      },
      sortings: {
        all: [
          {
            id: "byNameAsc",
            active: false,
            title: "По алфавиту",
            value: ["name ASC"],
          },
          {
            id: "byCreatedDesc",
            active: false,
            title: "По дате создания",
            value: ["created DESC"],
          },
        ],
        active: [],
      },
    };
  }
  componentDidMount() {
    this.renderButtons();
    this.setDefaultFilters();
    this.assignRights();
  }
  assignRights() {
    this.setState({
      rights: {
        manage: true,
      },
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.shipId !== this.props.shipId) {
      this.setDefaultFilters();
    }
    this.renderButtons();
  }
  refreshList = async () => {
    this.setState({ customListKey: this.context.key() });
  };

  setDefaultFilters = async () => {
    let shipId =
      this.props.shipId && this.props.shipId !== "any"
        ? this.props.shipId
        : null;
    this.setState((state) => {
      let filters = state.filters;
      filters.default = [];
      if (shipId) {
        filters.default.push({
          field: "ship",
          compare: "EQL",
          value: shipId,
        });
      }
      return filters;
    });
  };
  toggleFilters = (v) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.show = v;
      return { filters };
    });
  };
  handleFilters = (changedFilters) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };
  handleSortings = (chnagedSortings) => {
    this.setState((state) => {
      let sortings = state.sortings;
      sortings.active = chnagedSortings;
      return { sortings };
    });
  };
  handleSearch = (text) => {
    let search = text
      ? [
          {
            lstr: "(",
            field: "label",
            compare: "IKE",
            value: `%${text}%`,
            rstr: ")",
          },
        ]
      : [];
    this.setState({ search });
  };

  renderButtons = () => {
    if (this.state.rights.manage && !this.props.itemId) {
      this.context.actionsSet(
        <>
          <button
            onClick={() => this.onEditStart({})}
            title="Добавить документ"
            className={`btn  btn-icon btn-light mr-2`}
          >
            <i className="flaticon2-add-1 p-0 align-middle text-muted"></i>
          </button>
        </>
      );
    }
  };

  onEditStart = (item = {}) => {
    this.setState({ editItem: item });
  };

  onEditFinish = () => {
    this.setState({ editItem: false }, () => this.refreshList());
  };

  onEditClose = () => {
    this.setState({ editItem: false });
  };

  render() {
    const { shipId, itemId } = this.props;
    const { rights, editItem } = this.state;

    if (itemId) {
      return (
        <>
          <CrumbsProvider
            title="Судовые документы"
            link={`/certificate/${shipId}/`}
          />
          <div className="container">
            <CertificateItem itemId={itemId} rights={rights} />
          </div>
        </>
      );
    }

    return (
      <>
        {editItem && (
          <CertificateEdit
            item={editItem || {}}
            onClose={this.onEditClose}
            onFinish={this.onEditFinish}
            itemId={editItem ? editItem.id : null}
          />
        )}

        <CrumbsProvider title="Судовые документы" link="/certificate/" />
        <div className="container">
          <CertificateShipSelect shipId={shipId} rights={rights} />
          <div className="card card-custom mt-5">
            <div className="card-header px-5 py-2">
              <div className="card-title w-100 mr-0 p-lg-0 py-5 d-block d-lg-flex align-items-center justify-content-between">
                <div className="text-nowrap d-inline-block mr-2">
                  <Searchbox onSearch={this.handleSearch} />
                </div>
                <div>
                  <button
                    className="btn btn-light mr-2"
                    onClick={() => this.toggleFilters(!this.state.filters.show)}
                  >
                    <i
                      className={`fa fa-filter p-0 ${
                        this.state.filters.show ? "text-primary" : "text-muted"
                      }`}
                    ></i>
                  </button>
                  <Sortings
                    changeFn={this.handleSortings}
                    sortings={this.state.sortings.all}
                  />
                </div>
              </div>
            </div>
            <div
              className={`${
                this.state.filters.show ? "d-flex" : "d-none"
              }  align-items-center justify-content-end mt-0 py-5 px-7 mb-2 border-bottom w-100 shadow-sm`}
            >
              <Filters
                changeFn={this.handleFilters}
                filters={this.state.filters.all}
              />
            </div>
            <div className="card-body px-5">
              <List
                keyField="id"
                listKey="certificateList"
                path="/certificate/list"
                key={this.state.customListKey}
                fulltext={JSON.stringify(this.state.search)}
                search={JSON.stringify(
                  this.state.filters.active.concat(this.state.filters.default)
                )}
                sort={JSON.stringify(this.state.sortings.active)}
                limit={20}
              >
                <CertificateListItem
                  rights={rights}
                  onFinish={this.refreshList}
                  onEditClick={this.onEditStart}
                />
              </List>
            </div>
          </div>
        </div>
      </>
    );
  }
}
